const homeUrl = process.env.VUE_APP_FRONT_URL || 'https://huntica.online';

export default function useHomeUrl() {
  return { homeUrl };
}
